import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.completedSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.completedSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.completedSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.completedSettings.toggle.enable',
    }),
  }))

  return api
}
